import { setMeta, wipeDevice, type DeviceIdentity, type DeviceRow } from '@pos/local-db';
import { db } from '../lib/db.ts';
import { callFunction, supabase } from '../lib/supabase.ts';

/** Nombre sugerido para el dispositivo según el tipo de pantalla. */
export function suggestDeviceName(): string {
  const touch = matchMedia('(pointer: coarse)').matches;
  const wide = matchMedia('(min-width: 768px)').matches;
  if (touch && !wide) return 'Celular';
  if (touch) return 'Tablet';
  return 'Mostrador';
}

/** Habilita este dispositivo para el negocio (lo hace el dueño, con conexión). */
export async function enrollThisDevice(businessId: string, name: string): Promise<DeviceIdentity> {
  const res = await callFunction<{ device: DeviceRow; secret: string }>('enroll-device', {
    business_id: businessId,
    name: name.trim() || suggestDeviceName(),
  });
  const identity: DeviceIdentity = {
    id: res.device.id,
    business_id: businessId,
    code: res.device.code,
    name: res.device.name,
    secret: res.secret,
  };
  await setMeta(db, 'device', identity);
  await db.devices.put(res.device);
  return identity;
}

/** Borra todos los datos locales (dispositivo deshabilitado o cambio de negocio). */
export async function resetThisDevice(): Promise<void> {
  await wipeDevice(db);
  localStorage.removeItem('pos-saas-auth');
  await supabase.auth.signOut({ scope: 'local' }).catch(() => undefined);
}
